<template>
  <div class="cr-report-header" :class="className">
    <h2 class="cr-report-header__text">
      <slot></slot>
    </h2>
    <img
      :src="getImage"
      v-if="image"
      class="cr-report-header__image"
      alt="Alt description for the image"
    >
  </div>
</template>

<script>
export default {
  name: 'CardReportHeader',
  components: {},
  props: {
    image: {
      type: String,
      default: ''
    },
    farming: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    },
    className() {
      return `${(this.farming && 'cr-report-header--farming') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.cr-report-header {
  @apply flex flex-col items-start px-8 pb-20 pt-8 bg-primary-lightest;
}
.cr-report-header__image {
  @apply w-full;
}
.cr-report-header--farming .cr-report-header__image {
  @apply max-w-sm mx-auto;
}
.cr-report-header__text {
  @apply w-full;
}
@screen md {
  .cr-report-header__image {
    @apply w-7/12 mx-auto pl-8;
  }
  .cr-report-header--farming .cr-report-header__image {
    @apply w-4/12 pl-0 ml-0;
  }
  .cr-report-header {
    @apply flex-row items-center pt-0 bg-transparent;
    background-image: linear-gradient(to right, #f2f6f5 60%, white 0%);
  }
  .cr-report-header__text {
    @apply mb-0 w-5/12;
  }
}
</style>

